/* @flow weak */
import { List } from 'immutable'
import * as actions from './actions'
import { Record } from '../transit'

const State = Record({
  location: null,
  storageLoaded: false,
  loadingMessage: '',
  overlayInterface: false,
  errors: new List(),
  success: '',
  error: '',
  changedRoute: false,
  redirectAfterAuth: '',
  firstUrl: '',
  countryCode: 'en',
  userIp: '',
}, 'app')

const appReducer = (state = new State(), action) => {
  // This is how we can handle all async actions rejections.
  if (action.type.endsWith('_ERROR')) {
    const errors = action.payload.errors || action.payload

    if (typeof errors === 'string') {
      return state.set('error', errors)
    }
    return state.set('errors', new List(errors))
  }

  switch (action.type) {
    case actions.APP_SET_LOCATION:
      return state.set('location', action.payload.location)

    case actions.SET_COUNTRY_CODE_SUCCESS: {
      return state.set('countryCode', action.payload.country_code.toLowerCase())
                  .set('userIp', action.payload.IPv4)
    }

    case actions.APP_STORAGE_LOAD:
      return state.set('storageLoaded', true)

    case actions.SET_AFTER_AUTH_REDIRECT:
      return state.set('redirectAfterAuth', action.payload)

    case actions.SET_FIRST_URL:
      return state.set('firstUrl', action.payload)

    /* Messages are react intl messages IDs defined in FlashMessage component */
    case 'LESSON_DELETE_SUCCESS': {
      return state.set('success', 'lessonDeleted')
    }
    case 'LESSON_ADD_FAVORITE_SUCCESS':
    case 'LESSON_ADD_SUCCESS': {
      const user = state.get('viewer')
      if (!user) {
        return state
      }
      return state.set('success', 'lessonSaved')
    }
    case 'LESSON_REMOVE_FAVORITE_SUCCESS': {
      return state.set('success', 'lessonFavoriteDeleted')
    }
    case 'FOLLOW_USER_SUCCESS': {
      return state.set('success', 'followSuccess')
    }
    case 'TEST_EDIT_SUCCESS':
    case 'LESSON_EDIT_SUCCESS': {
      return state.set('success', 'changesSaved')
    }
    case 'TEST_ADD_SUCCESS': {
      const user = state.get('viewer')
      if (!user) {
        return state
      }
      return state.set('success', 'testSaved')
    }
    case 'TEST_DELETE_SUCCESS': {
      return state.set('success', 'testDeleted')
    }
    case 'RESULT_DELETE_SUCCESS': {
      return state.set('success', 'resultDeleted')
    }
    case 'SAMPLE_TESTS_CREATE_SUCCESS': {
      return state.set('success', 'sampleTestsCreated')
    }
    case 'CHANGE_PASSWORD_SUCCESS': {
      return state.set('success', 'passwordChanged')
    }
    case 'CLEAR_FLASH_MESSAGE': {
      return state.set('success', '').set('error', '')
    }
    case 'SHOW_ERROR': {
      return state.set('error', action.payload)
    }
    case actions.SET_CHANGED_ROUTE: {
      return state.set('changedRoute', true)
    }

    default:
      return state
  }
}

export default appReducer



// WEBPACK FOOTER //
// ./src/common/app/reducer.js